var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    d: "M13 5.5c-2.393 0-4.333 1.94-4.333 4.334 0 2.393 1.94 4.333 4.333 4.333 2.393 0 4.334-1.94 4.334-4.333C17.334 7.44 15.394 5.5 13 5.5zm0 2c1.289 0 2.334 1.045 2.334 2.334 0 1.288-1.045 2.333-2.334 2.333-1.288 0-2.333-1.045-2.333-2.333C10.667 8.545 11.712 7.5 13 7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    d: "M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zm0 2c6.075 0 11 4.925 11 11s-4.925 11-11 11S2 19.075 2 13 6.925 2 13 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    d: "M15.14 15.876c3.444 0 6.25 2.739 6.357 6.158l.003.201v.174c0 .552-.448 1-1 1-.518 0-.944-.394-.995-.898l-.005-.102v-.174c0-2.348-1.858-4.264-4.185-4.356l-.175-.004h-4.28c-2.35 0-4.265 1.859-4.357 4.185l-.003.175v.174c0 .552-.448 1-1 1-.518 0-.944-.394-.995-.898L4.5 22.41v-.174c0-3.444 2.739-6.25 6.158-6.356l.202-.003h4.28z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccount);
export default __webpack_public_path__ + "static/media/user-account.a59234e5.svg";
export { ForwardRef as ReactComponent };